export const STATISTIC_FIELDS = [
  "assists",
  "assistsPerGame",
  "assistsDefensive",
  "assistsTurnoverRatio",
  "blocks",
  "blocksPerGame",
  "blocksReceived",
  "doubleDouble",
  "draws",
  "efficiency",
  "fieldGoalsAttempted",
  "fieldGoalsMade",
  "fieldGoalsEffectivePercentage",
  "fieldGoalsPercentage",
  "freeThrowsAttempted",
  "freeThrowsMade",
  "freeThrowsPercentage",
  "foulsCoachDisqualifying",
  "foulsCoachTechnical",
  "foulsDisqualifying",
  "foulsOffensive",
  "foulsDrawn",
  "foulsPersonal",
  "foulsPersonalPerGame",
  "foulsTechnical",
  "foulsTotal",
  "foulsUnsportsmanlike",
  "games",
  "gamesPercentage",
  "gamesStarted",
  "indexOfSuccess",
  "losses",
  "minus",
  "minutes",
  "minutesPerGame",
  "plus",
  "plusMinus",
  "points",
  "pointsFastBreak",
  "pointsFastBreakAttempted",
  "pointsFastBreakMade",
  "pointsInThePaint",
  "pointsInThePaintMade",
  "pointsInThePaintAttempted",
  "pointsPerGame",
  "pointsSecondChance",
  "pointsSecondChanceAttempted",
  "pointsSecondChanceMade",
  "pointsTwoAttempted",
  "pointsTwoMade",
  "pointsTwoPercentage",
  "pointsThreeAttempted",
  "pointsThreeMade",
  "pointsThreePercentage",
  "rebounds",
  "reboundsPerGame",
  "reboundsDefensive",
  "reboundsDefensivePercentage",
  "reboundsDefensivePerGame",
  "reboundsOffensive",
  "reboundsOffensivePercentage",
  "reboundsOffensivePerGame",
  "reboundsPercentage",
  "steals",
  "stealsPercentage",
  "stealsPerGame",
  "tripleDouble",
  "trueShootingAttempts",
  "trueShootingPercentage",
  "turnovers",
  "turnoversPercentage",
  "turnoversPerGame",
  "wins",
] as const;

export type StatisticField = (typeof STATISTIC_FIELDS)[number];
